import { create } from 'zustand';
import { systemToolsService } from '../services/systemTools';
import type { SystemToolSettings } from '../types/systemTools';

interface SystemToolsState {
    settings: SystemToolSettings | null;
    isLoading: boolean;
    error: string | null;
    load: (force?: boolean) => Promise<void>;
    setSettings: (settings: SystemToolSettings) => void;
}

let pendingLoad: Promise<void> | null = null;

export const useSystemToolsStore = create<SystemToolsState>((set, get) => ({
    settings: null,
    isLoading: false,
    error: null,

    load: async (force = false): Promise<void> => {
        if (!force && get().settings) {
            return;
        }

        if (pendingLoad) {
            return pendingLoad;
        }

        set({ isLoading: true, error: null });
        pendingLoad = systemToolsService.getSettings()
            .then((settings) => set({ settings, isLoading: false, error: null }))
            .catch(() => set({
                isLoading: false,
                error: 'No se pudieron cargar las herramientas del sistema.',
            }))
            .finally(() => {
                pendingLoad = null;
            });

        return pendingLoad;
    },

    setSettings: (settings): void => set({ settings, error: null }),
}));
